import React, { PropsWithChildren, useEffect, useState } from 'react'
import { Drawer } from '@roo/roo'
import { useTranslation } from '@sailor/i18n-web'
import CommonTable from '@/components/CommonTable'
import { getI18nTime } from '@/common/utils/i18nFuncs'
import { useRequest } from 'ahooks'
import { fetchExcelUpdateLog } from '@/pages/rule/utils/api'
import { useFormContext } from '../../context/formContext'
import { IRulePackage, IUpdateExcelItem } from '@/pages/rule/utils/types'
import { getDateTimePattern } from '@/common/utils/i18n'


const UpdateLogDrawer: React.FC<PropsWithChildren> = (props) => {
  const [visible, setVisible] = useState(false)
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 20 })
  const { ruleData } = useFormContext()
  const { data: listRes, loading, run } = useRequest(() => fetchExcelUpdateLog({ ...pageInfo, rulePackageId: String(ruleData?.rulePackageId || '') }), { manual: true })

  useEffect(() => {
    if (visible) {
      run()
    }
  }, [pageInfo, visible]) // 分页信息改变或重新可见时,重新请求数据

  const { t } = useTranslation()

  const columns = [
    {
      title: t('e_pc_operation_time', '操作时间'), dataIndex: 'time',
      width: 120,
      render: (time:number, record: any) =>   getI18nTime(time),
    },
    {
      title: t('e_pc_operator', '操作人'), dataIndex: 'operator',
      width: 110,
    },
    {
      title: t('e_pc_operation_result', '操作结果'), dataIndex: 'resultMsg',
      width: 90,
    },
    {
      title: t('e_pc_result_download', '结果文件下载'), dataIndex: 'resultFileUrl',
      width: 120,
      render: (link:string, record:IUpdateExcelItem) => link ?  <a href={link}>{record.resultFileName || link?.split('/').pop()}</a> : '--',
    },
    {
      title: t('e_pc_import_download', '导入文件下载'), dataIndex: 'importFileUrl',
      width: 120,
      render: (link:any, record:IUpdateExcelItem) => link ? <a href={link}>{record.importFileName || link?.split('/').pop()}</a> : '--',
    },
  ]

  console.log(listRes)

  return (
    <>
      <div onClick={() => {setVisible(true)}}>{props.children}</div>
      <Drawer
        title={t('e_pc_update_log', '更新记录')}
        width={1000}
        onClose={() => {setVisible(false)}}
        visible={visible}
        placement="right"
      >
        <CommonTable
          rowKey="time"
          loading={loading}
          columns={columns}
          data={listRes?.result || []}
          pagination={{
            total: listRes?.totalCount,
            pageSize: pageInfo.pageSize,
            onChange: (pageNo: number, pageSize: number) => setPageInfo({ pageNo, pageSize }),
          }}
        />
      </Drawer>
    </>
  )
}


export default UpdateLogDrawer
